import Centre from "./models/Centre";

const tShirtCenters = [
    Centre.Adelaide,
    Centre.Albury,
    Centre.AliceSprings,
    Centre.Auckland,
    Centre.Ballarat,
    Centre.Berri,
    Centre.Brisbane,
    Centre.BrisbaneNorth,
    Centre.BrokenHill,
    Centre.Canberra,
    Centre.Cairns,
    Centre.Christchurch,
    Centre.Darwin,
    Centre.Dubbo,
    Centre.Gatton,
    Centre.Geelong,
    Centre.GoldCoast,
    Centre.Griffith,
    Centre.Hamilton,
    Centre.Hobart,
    Centre.Launceston,
    Centre.MelbourneEast,
    Centre.MelbourneMandir,
    Centre.MelbourneSouth,
    Centre.MelbourneWest,
    Centre.Mildura,
    Centre.Newcastle,
    Centre.Orange,
    Centre.PerthMandir,
    Centre.PerthSouth,
    Centre.Rotorua,
    Centre.Shepparton,
    Centre.SunshineCoast,
    Centre.Sydney,
    Centre.Toowoomba,
    Centre.Townsville,
    Centre.WaggaWagga,
    Centre.Wellington
];

const tShirtsAuCenters = [
    Centre.Adelaide,
    Centre.Albury,
    Centre.AliceSprings,
    Centre.Auckland,
    Centre.Ballarat,
    Centre.Berri,
    Centre.Brisbane,
    Centre.BrisbaneNorth,
    Centre.BrokenHill,
    Centre.Canberra,
    Centre.Cairns,
    Centre.Darwin,
    Centre.Dubbo,
    Centre.Gatton,
    Centre.Geelong,
    Centre.GoldCoast,
    Centre.Griffith,
    Centre.Hamilton,
    Centre.Hobart,
    Centre.Launceston,
    Centre.MelbourneEast,
    Centre.MelbourneMandir,
    Centre.MelbourneSouth,
    Centre.MelbourneWest,
    Centre.Mildura,
    Centre.Newcastle,
    Centre.Orange,
    Centre.PerthMandir,
    Centre.PerthSouth,
    Centre.Rotorua,
    Centre.Shepparton,
    Centre.SunshineCoast,
    Centre.Sydney,
    Centre.Toowoomba,
    Centre.Townsville,
    Centre.WaggaWagga,
];

const tShirtsWithFijiCenters = [...tShirtCenters, Centre.Ba, Centre.Nadi, Centre.Suva];

export default function getCentersForEventGroup(eventGroupName: string): Centre[] {
    const loweredEventGroupName = eventGroupName?.toLocaleLowerCase();
    switch (loweredEventGroupName) {
        case "sanskrit-conference-2026":
            return [
                Centre.Brisbane,
                Centre.MelbourneMandir,
                Centre.PerthMandir,
                Centre.Sydney,
                Centre.Canberra,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.Albury,
                Centre.BrisbaneNorth,
                Centre.Cairns,
                Centre.Darwin,
                Centre.Geelong,
                Centre.GoldCoast,
                Centre.Griffith,
                Centre.Hobart,
                Centre.MelbourneEast,
                Centre.Newcastle,
                Centre.PerthSouth,
                Centre.Shepparton,
                Centre.Toowoomba,
                Centre.Berri,
                Centre.Dubbo,
                Centre.Gatton,
                Centre.SunshineCoast,
                Centre.Townsville
            ];
        case "diwali-annakut-2025":
            return [
                Centre.Adelaide,
                Centre.Brisbane,
                Centre.MelbourneMandir,
                Centre.PerthMandir,
                Centre.Sydney,
                Centre.Canberra,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.Albury,
                Centre.BrisbaneNorth,
                Centre.Cairns,
                Centre.Darwin,
                Centre.Geelong,
                Centre.GoldCoast,
                Centre.Griffith,
                Centre.Hobart,
                Centre.MelbourneEast,
                Centre.Newcastle,
                Centre.PerthSouth,
                Centre.Shepparton,
                Centre.Toowoomba,
                Centre.Berri,
                Centre.Dubbo,
                Centre.Gatton,
                Centre.SunshineCoast,
                Centre.Townsville,
            ];
        case "anz-kishor-kishori-shibir":
            return [
                Centre.Sydney,
                Centre.MelbourneMandir,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.Brisbane,
                Centre.Canberra,
                Centre.Adelaide,
                Centre.Perth,
                Centre.PerthMandir,
                Centre.PerthSouth,
                Centre.Darwin
            ];
        case "bal-satsang-exam-2025":
        case "bal-balika-exam-2024":
            return [
                Centre.Adelaide,
                Centre.Albury,
                Centre.Auckland,
                Centre.Balwyn,
                Centre.BrisbaneNorth,
                Centre.Brisbane,
                Centre.Canberra,
                Centre.Christchurch,
                Centre.Cranbourne,
                Centre.Darwin,
                Centre.Geelong,
                Centre.GoldCoast,
                Centre.Hobart,
                Centre.MelbourneMandir,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.Perth,
                Centre.PerthSouth,
                Centre.Shepparton,
                Centre.Sydney,
                Centre.Wellington
            ];
        case "annakut-2024":
        case "annakut-2023":
            return [
                Centre.Adelaide,
                Centre.Albury,
                Centre.Ballarat,
                Centre.Bendigo,
                Centre.Brisbane,
                Centre.BrisbaneNorth,
                Centre.Canberra,
                Centre.Darwin,
                Centre.Geelong,
                Centre.GoldCoast,
                Centre.Griffith,
                Centre.Hobart,
                Centre.MelbourneMandir,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.MelbourneEast,
                Centre.Newcastle,
                Centre.PerthMandir,
                Centre.PerthSouth,
                Centre.Shepparton,
                Centre.Sydney,
                Centre.Toowoomba
            ];
        case "gold-coast-mandir-mahotsav-t-shirts":
            return [
                Centre.GoldCoast
            ];
        case "sunshine-coast-2025":
            return [
                Centre.SunshineCoast
            ];
        case "sydney-mandir-murti-pratishtha-t-shirts":
        case "sydney-madir-shilanyas-mahotsav-t-shirts":
            return [
                Centre.Sydney
            ];
        case "darwin-mandir-mahotsav-t-shirts": 
            return [ Centre.Darwin];
        case "1000-nakkar-vidwan-mahotsav-t-shirts":
        case "nilkanth-varni-murti-pratishtha-t-shirts":
        case "akshardham-bhumi-pujan-t-shirts":
        case "fuldol-2025-t-shirts":
        case "bhavya-yoddha-t-shirts":
        case "audio-visual-team-t-shirts":
            return tShirtsWithFijiCenters;
        case "msm-vicharan-2025":
            return [
                Centre.International,
                Centre.Adelaide,
                Centre.Albury,
                Centre.Auckland,
                Centre.Balwyn,
                Centre.Brisbane,
                Centre.Canberra,
                Centre.Christchurch,
                Centre.Darwin,
                Centre.Dubbo,
                Centre.Gatton,
                Centre.Geelong,
                Centre.GoldCoast,
                Centre.Gosford,
                Centre.Griffith,
                Centre.Hobart,
                Centre.MelbourneMandir,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.Mittagong,
                Centre.Newcastle,
                Centre.Perth,
                Centre.PerthMandir,
                Centre.PerthSouth,
                Centre.Shepparton,
                Centre.Sydney,
                Centre.Tamworth,
                Centre.Toowoomba,
                Centre.Wellington
            ];
        case "mamh-2026-conf-payments":
        case "anz-copr-conf-2025-payments":
        case "karcon-2025-payments" : 
        case "mslc-2026-payments" : 
            return    [
                Centre.Adelaide,
                Centre.Albury,
                Centre.Auckland,
                Centre.Ballarat,
                Centre.Berri,
                Centre.Brisbane,
                Centre.BrisbaneNorth,
                Centre.Christchurch,
                Centre.Cairns,
                Centre.Darwin,
                Centre.Dubbo,
                Centre.Gatton,
                Centre.Geelong,
                Centre.GoldCoast,
                Centre.Gosford,
                Centre.Griffith,
                Centre.Hobart,
                Centre.Hamilton,
                Centre.MelbourneEast,
                Centre.MelbourneMandir,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.Mittagong,
                Centre.MountGambier,
                Centre.Newcastle,
                Centre.PerthMandir,
                Centre.PerthSouth,
                Centre.Rotorua,
                Centre.Shepparton,
                Centre.SunshineCoast,
                Centre.Sydney,
                Centre.Tamworth,
                Centre.Toowoomba,
                Centre.Townsville,
                Centre.Wellington
        ];
        case "satsang-diksha-kit": return [
                Centre.Adelaide,
                Centre.Albury,
                Centre.Auckland,
                Centre.Ballarat,
                Centre.Berri,
                Centre.Brisbane,
                Centre.BrisbaneNorth,
                Centre.Canberra,
                Centre.Dubbo,
                Centre.Christchurch,
                Centre.Cairns,
                Centre.Darwin,
                Centre.Dubbo,
                Centre.Gatton,
                Centre.Geelong,
                Centre.GoldCoast,
                Centre.Gosford,
                Centre.Griffith,
                Centre.Hobart,
                Centre.Hamilton,
                Centre.MelbourneEast,
                Centre.MelbourneMandir,
                Centre.MelbourneSouth,
                Centre.MelbourneWest,
                Centre.Mittagong,
                Centre.MountGambier,
                Centre.Newcastle,
                Centre.PerthMandir,
                Centre.PerthSouth,
                Centre.Rotorua,
                Centre.Shepparton,
                Centre.SunshineCoast,
                Centre.Sydney,
                Centre.Tamworth,
                Centre.Toowoomba,
                Centre.Townsville,
                Centre.Wellington
        ];
        case "bk-sports-day-t-shirts":  return tShirtsAuCenters;
    };

    return [
        Centre.Adelaide,
        Centre.Albury,
        Centre.Auckland,
        Centre.Balwyn,
        Centre.Ballarat,
        Centre.Bathurst,
        Centre.Brisbane,
        Centre.Canberra,
        Centre.Christchurch,
        Centre.Darwin,
        Centre.Dubbo,
        Centre.Gatton,
        Centre.Geelong,
        Centre.GoldCoast,
        Centre.Gosford,
        Centre.Griffith,
        Centre.Hobart,
        Centre.International,
        Centre.MelbourneMandir,
        Centre.MelbourneSouth,
        Centre.MelbourneWest,
        Centre.Mittagong,
        Centre.Newcastle,
        Centre.Perth,
        Centre.PerthMandir,
        Centre.PerthSouth,
        Centre.Shepparton,
        Centre.Sydney,
        Centre.Tamworth,
        Centre.Toowoomba,
        Centre.Wellington,
        Centre.WaggaWagga
    ];
}
